import type { CSSProperties } from 'react';

export const transferStyles = {
  container: {
    marginTop: 8,
    width: '100%',
    overflow: 'hidden',
  } satisfies CSSProperties,
  transfer: {
    width: '100%',
  } satisfies CSSProperties,
  // Modal 900 - body padding 48 - operations ~56 => ~398 per list; leave a little slack.
  section: {
    width: 380,
    height: 380,
  } satisfies CSSProperties,
  title: {
    flex: 1,
    minWidth: 0,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    lineHeight: 1.35,
  } satisfies CSSProperties,
};

export const modalConfig = {
  width: 900,
  styles: {
    body: {
      overflowX: 'hidden' as const,
    },
  },
};
